const transformToDate = (path) => {
  const dateStr = path.split('_')[0].slice(0, -1);
  const formatted = `${dateStr.slice(0, 2)}/${dateStr.slice(2, 4)}/${dateStr.slice(4)}`;
  return formatted;
};
export default transformToDate;